import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class LargeClayPitBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.LARGE_CLAY_PIT;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default LargeClayPitBuildingTileEntity;
